module.exports = __webpack_public_path__ + "card.png?79e265de707de5b912eb02d7f065f9ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card.png
// module id = 162
// module chunks = 0